<template>
  <div class="LoginWrapper">
    <form class="login" @submit.prevent="onLogin">
      <h1 class="Header">INLOGG</h1>
      <input required v-model="email" type="email" placeholder="Email" />
      <input
        required
        v-model="password"
        type="password"
        placeholder="Lösenord"
      />
      <button type="submit">Login</button>
      <button type="button" @click="onLogout">Logout</button>
    </form>
  </div>
</template>

<script>
import { login, logout} from "@/firebase"

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    onLogin() {
      login(this.email, this.password);
    },
    onLogout() {
      logout();
    },
  },
};
</script>
<style scoped>
.LoginWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cell {
  padding: 25px;
}
.cell input {
  width: 60%;
  float: right;
}
.cell label {
  width: 35%;
  float: left;
}
</style>